export const TAG_TYPES = ['FIN_TERMS', 'Stories'] as const
